import Vue from "vue";
import VueRouter from "vue-router";
import analytics from "../utils/analytics";
import auth from "../utils/auth";
import store from "../store/index";
import notifications from "../utils/notifications";

Vue.use(VueRouter);
const Home = () => import("../components/Home/Home.vue");
const Search = () => import("../components/Search/Index.vue");
const DownloadFixtures = () =>
	import("../components/DownloadFixtures/Index.vue");
const Shikisha = () => import("../components/Shikisha/Index.vue");
const MainBetslip = () => import("../components/Betslip/MainBetslip.vue");
const PrebetMarkets = () => import("../components/Prebets/Markets.vue");
const Countries = () => import("../components/Prebets/Countries.vue");
const ShikishaMarkets = () => import("../components/Shikisha/Markets.vue");
const Login = () => import("../components/Session/Login.vue");
const Register = () => import("../components/Session/Register.vue");
const KycInitial = () => import("../components/Session/KycInitial.vue");
const KycAllRequirements = () =>
	import("../components/Session/KycAllRequirements.vue");
const Profile = () => import("../components/Session/Account/Index.vue");
const Transactions = () =>
	import("../components/Session/Account/Transactions.vue");
const MyBets = () => import("../components/Session/MyBets.vue");
const MyBetsBetDetail = () => import("../components/Session/BetDetail.vue");
const WeeklyJackpot = () => import("../components/Jackpots/Index.vue");
const GrandJackpotEvent = () => import("../components/Jackpots/Event.vue");
const WeeklyJackpotResults = () => import("../components/Jackpots/Results.vue");
const MidweekJackpot = () => import("../components/Jackpots/MidweekEvent.vue");
const JackpotResult = () => import("../components/Jackpots/Result.vue");
const Live = () => import("../components/Live/Matches.vue");
const LiveMarkets = () => import("../components/Live/Markets.vue");
const ResetPassword = () => import("../components/Session/ResetPassword.vue");
const LiveScore = () => import("../components/Live/LiveScore.vue");

const BoostedMultibet = () => import("../components/BoostedMultibet/Index.vue");
const BoostedMultibetEvents = () =>
	import("../components/BoostedMultibet/Events.vue");
const BoostedMultibetEvent = () =>
	import("../components/BoostedMultibet/Event.vue");

const Virtuals = () => import("../components/Virtuals/Index.vue");
const Leagues = () => import("../components/Virtuals/Leagues.vue");
const Matchdays = () => import("../components/Virtuals/Matchdays.vue");
const Ongoing = () => import("../components/Virtuals/Ongoing.vue");
const Table = () => import("../components/Virtuals/Table.vue");
const Results = () => import("../components/Virtuals/Results.vue");
const VirtualMarkets = () => import("../components/Virtuals/Markets.vue");
const Casino = () => import("../components/Casino/Games.vue");
const CasinoCategoryDetail = () =>
	import("../components/Casino/CategoryDetail.vue");
const CasinoGamePage = () => import("../components/Casino/GamePage.vue");
const Share = () => import("../components/Share/Index.vue");
const splitPotGamePage = () => import("../components/Stp/GamePage.vue");
const splitPot = () => import("../components/Stp/Games.vue");
const GoldenRaceGames = () => import("../components/GoldenRaceGames/Index.vue");
const Notifications = () => import("../components/Notifications/Index.vue");
const NotificationsDetails = () =>
	import("../components/Notifications/NotificationDetails.vue");
const TermsAndConditions = () =>
	import("../components/TermsAndConditions/Index.vue");
const TermsAndConditionsSubCategories = () =>
	import("../components/TermsAndConditions/SubCategories.vue");
const TermsAndConditionsMiniCategoriesOrContent = () =>
	import("../components/TermsAndConditions/MiniCategoriesOrContent.vue");
const TermsAndConditionsMiniCategory = () =>
	import("../components/TermsAndConditions/MiniCategory.vue");
const FreeBets = () => import("../components/Offers/FreeBets/Index.vue");
const FreeBetsDetails = () =>
	import("../components/Offers/FreeBets/FreebetDetail.vue");
const FreeBetsOfferSingle = () =>
	import("../components/Offers/Promos/Single.vue");
const PromosList = () => import("../components/Offers/Promos/Index.vue");

import { env } from "../utils/env";
module.exports = {
	initializeRoutes: function(callback) {
		const routes = [
			{
				path: "/betslip",
				name: "betslip",
				component: MainBetslip,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/",
				name: "home",
				component: Home,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: true,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/search",
				name: "search",
				component: Search,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: true,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/s/:sportName",
				name: "sport",
				component: Home,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: true,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
				children: [
					{
						path: "/s/:sportName/countries",
						name: "sport-countries",
						component: Countries,
						meta: {
							miniBetslipViewable: false,
							showLiveNav: false,
							showPrematchNav: true,
							showBetslip: true,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
				],
			},
			{
				path: "/s/:sportName/:competitionName",
				name: "sport-competition",
				component: Home,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: true,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/m/:matchId",
				name: "prebet-markets",
				component: PrebetMarkets,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: true,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				name: "login",
				path: "/login",
				component: Login,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: false,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				name: "register",
				path: "/register",
				component: Register,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: false,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				name: "kyc",
				path: "/kyc",
				component: KycInitial,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: false,
					showHeader: true,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				name: "kyc-all-requirements",
				path: "/kyc-all-requirements",
				component: KycAllRequirements,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: false,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},

			{
				name: "profile",
				path: "/profile",
				component: Profile,

				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: true,
					requireKYC: false,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/profile/transactions",
				component: Transactions,

				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: true,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/mybets",
				name: "mybets",
				component: MyBets,

				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: true,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				name: "mybets-betdetail",
				path: "/mybets/:betId",
				component: MyBetsBetDetail,

				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: true,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				name: "mybets-betdetail-short",
				path: "/b/:shortBetId",
				component: MyBetsBetDetail,

				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: true,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/live",
				name: "live",
				component: Live,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: true,
					showPrematchNav: false,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/live/:sportName",
				name: "live-sport",
				component: Live,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: true,
					showPrematchNav: false,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/live/m/:matchId",
				name: "live-markets",
				component: LiveMarkets,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: true,
					showPrematchNav: false,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/forgotpassword",
				component: ResetPassword,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/share/:shareCode",
				name: "share-receiver",
				component: Share,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/share",
				name: "share-receiver",
				component: Share,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/notifications",
				name: "notifications",
				component: Notifications,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: true,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/notifications/details",
				name: "notifications-details",
				component: NotificationsDetails,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: true,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/legal",
				name: "termsAndConditions",
				component: TermsAndConditions,
				props: true,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/legal/:categoryName",
				name: "termsAndConditions",
				component: TermsAndConditionsSubCategories,
				props: true,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/legal/:categoryName/:subCategoryName",
				name: "termsAndConditions",
				component: TermsAndConditionsMiniCategoriesOrContent,
				props: true,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/legal/:categoryName/:subCategoryName/:miniCategoryName",
				name: "termsAndConditions",
				component: TermsAndConditionsMiniCategory,
				props: true,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/freebets",
				name: "free-bets",
				component: FreeBets,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/freebets/:id",
				name: "free-bets-detail",
				component: FreeBetsDetails,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/freebets/offers/:promoId",
				name: "free-bets-offer-single",
				component: FreeBetsOfferSingle,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/offers",
				name: "offers",
				component: PromosList,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "*",
				component: Home,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: true,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
		];

		const livescoreRoutes = [
			{
				path: "/livescore",
				name: "livescore",
				component: LiveScore,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: true,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
		];

		if (env.availableProducts.includes("livescore"))
			routes.push(...livescoreRoutes);

		const downloadFixturesRoutes = [
			{
				name: "download-fixtures",
				path: "/download-fixtures",
				component: DownloadFixtures,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: false,
					showFooter: false,
					showLeftNav: true,
					showRightNav: true,
				},
			},
		];

		if (env.availableProducts.includes("downloadFixtures"))
			routes.push(...downloadFixturesRoutes);

		/**
		 *  Configurable routes
		 *  */
		const goldenRaceRoutes = [
			{
				path: "/betika-super-league",
				name: "betika-super-league",
				component: GoldenRaceGames,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					showLeftNav: false,
					showRightNav: false,
				},
			},
		];

		if (env.availableProducts.includes("goldenRace"))
			routes.push(...goldenRaceRoutes);

		const casinoRoutes = [
			{
				path: "/casino",
				name: "casino",
				component: Casino,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					centerOnlyLayout: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/casino/category/:categoryName",
				name: "casino-category",
				component: CasinoCategoryDetail,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					centerOnlyLayout: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/casino/g/",
				name: "casino-game",
				component: CasinoGamePage,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					centerOnlyLayout: true,
					showLeftNav: false,
					showRightNav: false,
				},
			},
		];
		if (env.availableProducts.includes("casino")) routes.push(...casinoRoutes);
		const splitPotNameBaseRoute =
			env.availableProducts.includes("splitPot") &&
			env.splitPotName.replace(/\s/gi, "-").toLowerCase();

		const splitPotRoutes = [
			{
				path: `/${splitPotNameBaseRoute}`,
				name: `${splitPotNameBaseRoute}`,
				component: splitPot,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					centerOnlyLayout: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: `/${splitPotNameBaseRoute}/:id`,
				name: `${splitPotNameBaseRoute}-game`,
				component: splitPotGamePage,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: false,
					showTopNav: false,
					showFooter: false,
					centerOnlyLayout: true,
					showLeftNav: false,
					showRightNav: false,
				},
			},
		];
		if (env.availableProducts.includes("splitPot"))
			routes.push(...splitPotRoutes);

		const virtualsRoutes = [
			{
				path: "/virtual",
				name: "virtual",
				component: Leagues,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: "/virtuals",
				name: "virtuals",
				component: Virtuals,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
				children: [
					{
						path: "matches/:id",
						name: "virtuals-matches",
						components: {
							default: Matchdays,
						},
						meta: {
							miniBetslipViewable: true,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: true,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: "table/:id",
						name: "virtuals-table",
						components: {
							default: Table,
							main: Matchdays,
						},
						meta: {
							miniBetslipViewable: true,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: true,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: "results/:id",
						name: "virtuals-results",
						components: {
							default: Results,
							main: Matchdays,
						},
						meta: {
							miniBetslipViewable: true,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: true,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: "ongoing/:id",
						name: "virtuals-ongoing",
						components: {
							default: Ongoing,
							main: Matchdays,
						},
						meta: {
							miniBetslipViewable: true,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: true,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: "markets/:id",
						name: "virtuals-markets",
						components: {
							default: null,
							main: VirtualMarkets,
						},
						meta: {
							miniBetslipViewable: true,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: true,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: false,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
				],
			},
		];
		if (env.availableProducts.includes("virtuals"))
			routes.push(...virtualsRoutes);

		const shikishaBaseRoute = env.shikishaProductName
			.replace(/\s/gi, "-")
			.toLowerCase();

		const shikishaRoutes = [
			{
				path: `/${shikishaBaseRoute}`,
				name: `${shikishaBaseRoute}`,
				component: Shikisha,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
			{
				path: `/${shikishaBaseRoute}/markets/:parentMatchId`,
				name: `${shikishaBaseRoute}-markets`,
				component: ShikishaMarkets,
				meta: {
					miniBetslipViewable: true,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: true,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
			},
		];

		if (env.availableProducts.includes("shikisha"))
			routes.push(...shikishaRoutes);

		const jackpotRoutes = [
			{
				name: "jackpots",
				path: "/jackpots",
				component: WeeklyJackpot,
				alias: "/jackpot",
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
				children: [
					{
						path: "",
						name: "grand-jackpot",
						component: GrandJackpotEvent,
						meta: {
							miniBetslipViewable: false,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: false,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: "/jackpots/midweekjp",
						name: "midweek-jackpot",
						component: MidweekJackpot,
						meta: {
							miniBetslipViewable: false,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: false,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: "/jackpots/results",
						name: "jackpot-results",
						component: WeeklyJackpotResults,
						alias: "/jackpot/results",
						meta: {
							miniBetslipViewable: false,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: false,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: "/jackpots/result",
						name: "jackpot-result",
						component: JackpotResult,
						alias: "/jackpot/result",
						meta: {
							miniBetslipViewable: false,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: false,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
				],
			},
		];

		const sababishaBaseRoute = env.sababishaProductName
			.replace(/\s/gi, "-")
			.toLowerCase();
		const dailyJpRoutes = [
			{
				path: `/jackpots/${sababishaBaseRoute}`,
				name: "boosted-multibet",
				alias: `/${sababishaBaseRoute}`,
				component: BoostedMultibet,
				meta: {
					miniBetslipViewable: false,
					showLiveNav: false,
					showPrematchNav: false,
					showBetslip: false,
					requireAuth: false,
					requireKYC: env.kyc.required,
					showHeader: true,
					showTopNav: true,
					showFooter: true,
					showLeftNav: true,
					showRightNav: true,
				},
				children: [
					{
						path: "",
						name: "boosted-multibet-events",
						component: BoostedMultibetEvents,
						meta: {
							miniBetslipViewable: false,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: false,
							requireAuth: false,
							requireKYC: env.kyc.required,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
					{
						path: `/jackpots/${sababishaBaseRoute}/:id`,
						name: "boosted-multibet-event",
						component: BoostedMultibetEvent,
						meta: {
							miniBetslipViewable: false,
							showLiveNav: false,
							showPrematchNav: false,
							showBetslip: false,
							requireAuth: false,
							requireKYC: true,
							showHeader: true,
							showTopNav: true,
							showFooter: true,
							showLeftNav: true,
							showRightNav: true,
						},
					},
				],
			},
		];

		if (env.availableProducts.includes("dailyJp"))
			jackpotRoutes[0].children.push(...dailyJpRoutes);

		if (env.availableProducts.includes("jackpots"))
			routes.push(...jackpotRoutes);

		const router = new VueRouter({
			routes,
			scrollBehavior(to, from, savedPosition) {
				if (savedPosition) {
					return savedPosition;
				} else {
					return { x: 0, y: 0 };
				}
			},
			base: process.env.baseUrl,
			mode: "history",
		});

		router.beforeEach((to, from, next) => {
			if (to.meta.requireAuth && !auth.getAuthStatus()) {
				return router.push({ name: "login", query: { next: to.fullPath } });
			}

			if (
				to.meta.requireKYC &&
				auth.getAuthStatus() &&
				typeof store.getters.user.has_kyc !== "undefined" &&
				store.getters.user.has_kyc === false
			) {
				notifications.addNotificationBannerMessage(
					"Complete Your Application",
					"Due to government regulation in your country, additional details are required for you to enjoy the full Betika experience.",
					"Complete my application",
					"/kyc"
				);

				return router.push({ name: "kyc", query: { next: to.fullPath } });
			}
			analytics.general.pageMetaData({
				type: to.name,
				title: to.name,
				path: to.fullPath,
			});
			next();
		});

		callback(router);
	},
};
